import { logger } from './logger';

/**
 * Initialize global error handlers for catching unhandled errors
 * Call this once at app startup (in main.tsx)
 */
export const initGlobalErrorHandlers = () => {
  // Listeners, not `window.onerror = …` / `window.onunhandledrejection = …`:
  // Sentry's GlobalHandlers integration installs itself by assigning those very
  // properties during Sentry.init (which runs before this). Assigning them here
  // used to replace Sentry's hooks, so unhandled rejections — and any uncaught
  // error outside the APIs Sentry wraps — never reached error tracking.

  // Handle uncaught JavaScript errors
  window.addEventListener('error', (event: ErrorEvent) => {
    logger.error('Uncaught error', event.error || new Error(String(event.message)), {
      source: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      url: window.location.href,
    });
    // Not calling preventDefault(): the error keeps propagating as before
  });

  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    logger.error('Unhandled promise rejection', event.reason, {
      url: window.location.href,
      type: 'unhandledrejection',
    });
  });

  // Flush logs before page unload
  window.addEventListener('beforeunload', () => {
    logger.flush();
  });

  // Also flush on visibility change (mobile background)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      logger.flush();
    }
  });
};
